module.exports = __webpack_public_path__ + "static/media/20201129_220737_989_IMG_1929.728ea715.jpg";